import { render, staticRenderFns } from "./TeacherMore.vue?vue&type=template&id=c8cea702&scoped=true&"
import script from "./TeacherMore.vue?vue&type=script&lang=js&"
export * from "./TeacherMore.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMore.vue?vue&type=style&index=0&id=c8cea702&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cea702",
  null
  
)

export default component.exports